/* eslint-disable no-undef */
(function ($) {

  function newsSlider() {
    if (!$('#news-slider').hasClass('splide-initialized')) {
      new Splide('#news-slider', {
        perPage: 4,
        perMove: 1,
        gap: 16,
        speed: 2000,
        pagination: true,
        autoHeight: true,
        breakpoints: {
          576: {
            perPage: 1,
            padding: { right: '10%' },
            arrows: false,

          },
          1200: {
            perPage: 3,
            padding: { right: '20%' },
            arrows: false,

          },
        },
      }).mount();
    }
  }

  /* eslint-disable no-undef */
  function initTinySlider() {
    new Splide('#numberheroslide', {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      gap: 0,
      pagination: true,
      autoHeight: true,
      arrows: false,
      drag: false,
      breakpoints: {
        576: {
          perPage: 1,
          drag: true,
          arrows: true,
        },
        900: {
          perPage: 2,
          drag: true,
          arrows: true,
        },
        1200: {
          perPage: 3
        }
      }
    }).mount();
  }

  function contentSlider() {
    if (!$('#content-slider').hasClass('splide-initialized')) {
      new Splide('#content-slider', {
        perPage: 3,
        perMove: 1,
        gap: 48,
        speed: 2000,
        pagination: true,
        autoHeight: true,
        breakpoints: {
          576: {
            perPage: 1,
            padding: { right: '10%' },
            arrows: false,

          },
          1200: {
            perPage: 2,
            padding: { right: '20%' },
            arrows: false,
            gap: 16,
          },
        },
      }).mount();
    }
  }

  function timelineSlider() {
    if (!$('#timeline-slider').hasClass('splide-initialized')) {
      new Splide('#timeline-slider', {
        perPage: 3,
        perMove: 1,
        focus: 'center',
        start: 1,
        gap: 48,
        speed: 1000,
        pagination: true,
        autoHeight: true,
        breakpoints: {
          576: {
            perPage: 1,
            padding: { right: '0' },
            arrows: false,

          },
          1200: {
            perPage: 2,
            padding: { right: '10%' },
            arrows: false,
            gap: 16,
            start: 0,

          },
        },
      }).mount();
    }
  }

  $(document).ready(newsSlider);
  $(document).ready(contentSlider);
  $(document).ready(initTinySlider);
  $(document).ready(timelineSlider);

}(jQuery));
